
import { basePath, apiVersion } from "./config";

export async function getPersonalicencia (token, query) {
  const url = `${basePath}/${apiVersion}/licencias${query}`;


  const params = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      'Authorization': token
    },

  };
  return await fetch(url, params)
    .then(response => {
      return response.json();
    })
    .then(result => {
      return result;
    })
    .catch(err => {
      return err;
  });
}


export async function  getLicenciaDetalle (token,id) {
  const url = `${basePath}/${apiVersion}/licencia/${id}`;

  const params = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  try {
    const response = await fetch(url, params);
    const result = await response.json();

    if (!response.ok) {
      const error = new Error(result.mensaje || "Error en la consulta de personas");
      error.endpoint = url;
      error.backendMessage = result.detalles || JSON.stringify(result);
      throw error;
    }

    return result;

  } catch (err) {
    if (!err.endpoint) {
      err.endpoint = url;
    }
    throw err;
  }
}



